import { useAuth0 } from "@auth0/auth0-react";
import { IconButton, TableContainer } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import { ReactComponent as FilterIcon } from "assets/icons/Filter.svg";
import { ReactComponent as SortIcon } from "assets/icons/SortIcon.svg";
import Action from "components/ActionPopOver";
import ClearGroupFilter from "components/clearGroupFilter/index";
import AlertDialog from "components/Dialog";
import Loader from "components/loader/Loader";
import MyFilterButton from "components/MyFilterButton";
import SearchComp from "components/Searchcomponent";
import { formatDate } from "helper/dateFormat";
import CommunicationService from "Lib/API/Communication";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  setCampaignEditData,
  setCardContent,
  setCreateCampaignDialog,
  setFormTemplateCampainPage,
  setOpenTemplateCreationDialog,
  setPreviewTemplete,
  setSelectedTemplate
} from "services/api/communication";
import { Content, SearchWrapper, StatusWrapper, Title } from "./Theme";
import { fontConfig } from "theme/fontConfig";
export const CampaignTable = ({
  setToggle,
  campaignList,
  page,
  setPage,
  loading,
  onSortChange,
  searchValue,
  handleInputChange,
  count,
  handleSort,
  refresh,
  setRefresh,
  setCampainDetailsId,
  resetSearchParams,
  campaignIdParam
}) => {
  const headerTitles = [
    { title: "CAMPAIGN", sortName: "campaignName" },
    { title: "SENT", sortName: "sent" },
    { title: "OPENED", sortName: "opened" },
    { title: "CLICKED", sortName: "clicked" },
    { title: "BOUNCED", sortName: "bounced" },
    { title: "UNSUBSCRIBED", sortName: "unsubscribed" },
    { title: "DATE CREATED", sortName: "createdAt" },
    { title: "STATUS", sortName: "status" },
    { title: "SELECTED TEMPLATE", sortName: "template" },
    { title: "", sortName: "", className: "sticky-header-column" },
  ];
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [deleteCapmaignId, setDeleteCapmaignId] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [duplicateCampaignId, setDuplicateCampaignId] = useState(null);
  const TableCellHead = withStyles((theme) => ({
    root: {
      height: "39px",
      padding: "0px 20px",
      borderBottom: "none",
      fontFamily: fontConfig.GeneralTableCellHeadFont.family,
    },
  }))(TableCell);
  const TableCellBody = withStyles((theme) => ({
    root: {
      height: "65px",
      padding: "0px 20px",
      fontFamily: fontConfig.GeneralTableCellBodyFont.family,
      fontSize: "14px",
      color: "#4f4f4f",
    },
  }))(TableCell);
  const useStyles = makeStyles({
    tableRow: {
      "&:hover": {
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        backgroundColor: "#e6ecf05e",
        cursor: "pointer",
      },
    },
  });
  const classes = useStyles();

  const deleteCapmaign = async (id) => {
    setConfirmLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const result = await CommunicationService.deleteCampaign(token, id);
      toastr.success("Success", "Campaign Deleted Successfully!");

      setRefresh(!refresh);
    } catch (err) {
      toastr.error("Error", err?.data?.message);
    } finally {
      setConfirmLoading(false);
      setDeleteCapmaignId(null);
      setConfirmDialog(false);
    }
  };
  const duplicateCapmaign = async () => {
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await CommunicationService.duplicateCampaign(token, duplicateCampaignId);
      toastr.success("Success", "Capmaign Duplicated Successfully!");
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setDuplicateCampaignId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };
  const handlePauseStartAction = async (status, id) => {
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result =
        status === "scheduled"
          ? await CommunicationService.pauseCampaign(token, id)
          : status === "paused"
          ? await CommunicationService.startCampaign(token, id)
          : "";
      toastr.success("Success", "Update Successfully!");
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setDuplicateCampaignId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };
  return (
    <>
      <Content>
        <Title>Campaigns</Title>
        <MyFilterButton
          className="campaign_filter"
          title="All"
          items={[
            { label: "Draft", value: "draft" },
            { label: "Paused", value: "paused" },
            { label: "Completed", value: "completed" },
            { label: "Scheduled", value: "scheduled" },
            { label: "All", value: "all" },
          ]}
          icon={<FilterIcon style={{ width: "19px", height: "17px" }} />}
          onChange={(sortValue) => {
            onSortChange(sortValue);
            resetSearchParams();
          }}
        />
        <SearchWrapper>
          <SearchComp
            value={searchValue}
            setSearchText={handleInputChange}
            placeholder="Search"
            style={{ width: "20.5rem", backgroundColor: "#fff" }}
          />
        </SearchWrapper>
        <div className="ml-4">
          {campaignIdParam && (
            <ClearGroupFilter />
          )}
        </div>
      </Content>

      <>
        <div
          style={{ paddingLeft: "17px", paddingRight: "17px", marginTop: 20 }}
        >
          <TableContainer className="scroll-table">
            <Table aria-label="collapsible table">
              <TableHead className="charges-table sticky-table-header">
                <TableRow>
                  {headerTitles.map((item) => (
                    <TableCellHead
                      className={`class__header__cell className_head ${item.className}`}
                      key={item}
                    >
                      <div>
                        {item?.title}
                        {item?.sortName !== "" && (
                          <IconButton>
                            <SortIcon
                              onClick={() => handleSort(item?.sortName)}
                            />
                          </IconButton>
                        )}
                      </div>
                    </TableCellHead>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody
                style={{
                  backgroundColor: "white",
                }}
              >
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <div className="user__loader" style={{ height: "320px" }}>
                        <Loader />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : campaignList?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <h6 style={{ height: "320px", marginTop: "100px" }}>
                        No Campaign Found
                      </h6>
                    </TableCell>
                  </TableRow>
                ) : (
                  campaignList?.map((row, i) => (
                    <React.Fragment key={row?._id}>
                      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                        <TableCellBody
                          className="status-head main-width-class"
                          component="th"
                          scope="row"
                          onClick={() => {
                            setCampainDetailsId(row?._id);
                          }}
                        >
                          <div className="transaction-status">
                            <div style={{ width: 22 }}></div>
                            <div className="pl-0">
                              <div className="school-table-class-name">
                                {row?.campaignName}
                              </div>
                            </div>
                          </div>
                        </TableCellBody>
                        <TableCellBody
                          className="paid-head main-width-class"
                          align="left"
                        >
                            {row?.sent}
                        </TableCellBody>

                        <TableCellBody
                          style={{
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="paid-head main-width-class"
                          align="left"
                        >
                          {row?.opened}
                        </TableCellBody>

                        <TableCellBody
                          style={{
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="paid-head main-width-class"
                          align="left"
                        >
                          {row?.clicked}
                        </TableCellBody>
                        <TableCellBody
                          style={{
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="paid-head main-width-class"
                          align="left"
                        >
                          {row?.bounced}
                        </TableCellBody>
                        <TableCellBody
                          style={{
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="paid-head main-width-class"
                          align="left"
                        >
                          {row?.unsubscribed}
                        </TableCellBody>
                        <TableCellBody
                          className="transaction-head main-width-class"
                          align="left"
                        >
                          {row?.createdAt && formatDate({date:row?.createdAt, formatType: "defaultWithUTC"})}
                        </TableCellBody>
                        <TableCellBody
                          style={{
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="paid-head main-width-class"
                          align="left"
                        >
                          <StatusWrapper status={row?.status}>
                            {row?.status &&
                              row?.status[0]?.toString()?.toUpperCase() +
                                row?.status.slice(1)}
                          </StatusWrapper>
                        </TableCellBody>
                        <TableCellBody
                          className="status-head main-width-class"
                          component="th"
                          scope="row"
                          onClick={() => {
                            if(row?.campaignType === "email"){
                            setToggle("Templates");
                            dispatch(setOpenTemplateCreationDialog(true));
                            dispatch(setPreviewTemplete(true));
                            dispatch(setFormTemplateCampainPage(row?.template));
                            }
                          }}
                        >
                          {row?.campaignType !== "email" ? (
                            <span>{row?.campaignType === "push" ? "Push Notification" : row?.campaignType === "whatsapp" ? "WhatsApp" : "Text Message"}</span>
                          ) : (
                            <div className="transaction-status">
                              <div style={{ width: 22 }}></div>
                              <div className="pl-0">
                                <div className="school-table-class-name">
                                  {row?.template?.title}
                                </div>
                              </div>
                            </div>
                          )}
                        </TableCellBody>

                        <TableCellBody
                          className="exp-action-head main-width-class sticky-body-column"
                          align="right"
                        >
                          <div
                            style={{
                              cursor: "pointer",
                              paddingleft: "0px",
                              zIndex: 1000,
                            }}
                          >
                            <Action
                              action="communication"
                              style={{ width: "16px" }}
                              onEditClick={() => {
                                const cardCon = row?.campaignType === "sms" ? "Text message" : row?.campaignType === "push" ? "Push notification" : row?.campaignType === "whatsapp" ? "WhatsApp" : "My template"
                                dispatch(setCreateCampaignDialog(true));
                                dispatch(setCardContent(cardCon));
                                dispatch(setCampaignEditData(row));
                                dispatch(setSelectedTemplate(row?.template || {}));
                              }}
                              isEditHide={row?.status === "completed"}
                              onPauseStart={() => {
                                handlePauseStartAction(row?.status, row?._id);
                              }}
                              pauseOrStart={
                                row?.status === "scheduled"
                                  ? "Pause"
                                  : row?.status === "paused"
                                  ? "Start"
                                  : ""
                              }
                              onDeleteClick={() => {
                                setDeleteCapmaignId(row?._id);
                                setConfirmDialog(true);
                              }}
                              onDuplicateClick={() => {
                                setDuplicateCampaignId(row?._id);
                                setConfirmDialog(true);
                              }}
                            />
                          </div>
                        </TableCellBody>
                      </TableRow>
                    </React.Fragment>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {campaignList?.length > 0 && (
          <div className="pagination-custom mt-9">
            <Pagination
              count={Math.ceil(count / 30)}
              color="primary"
              variant="outlined"
              page={page + 1}
              onChange={(event, value) => {
                setPage(value - 1);
              }}
            />
          </div>
        )}
      </>
      <AlertDialog
        open={confirmDialog}
        onDecline={() => {
          if (deleteCapmaignId) {
            setDeleteCapmaignId(null);
          }
          if (duplicateCampaignId) {
            setDuplicateCampaignId(null);
          }
          setConfirmDialog(false);
        }}
        onAccept={() => {
          if (deleteCapmaignId) {
            deleteCapmaign(deleteCapmaignId);
          }
          if (duplicateCampaignId) {
            duplicateCapmaign(duplicateCampaignId);
          }
        }}
        title={"Are you sure?"}
        description={`Do you want to ${
          duplicateCampaignId ? "duplicate" : "delete"
        } this campaign?`}
        disabled={confirmLoading}
      />
    </>
  );
};
